<template>
  <base-action-button @action="load">
    <template #prepend><PhUserPlus style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
    {{ $store.getters.translate("convert_candidate_in_contact") }}
  </base-action-button>
  <base-draggable-modal
      name="base_create_contact"
      max-height="80vh"
      width="50vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="base_create_contact">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate("create_contact") }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-text-field
                density="default"
                variant="plain"
                color="primary"
                class="reg-normal mt-3"
                hide-details
                readonly
                persistent-placeholder
                v-model="record.contact_email">
              <template #label>
                <span class="sm-bold text-primary">{{ $store.getters.translate('email_for_new_contact_account') }}<strong>*</strong></span>
              </template>
            </v-text-field>
            <v-text-field
                density="default"
                class="reg-normal text-primary mt-3"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.candidate_email"
                hide-details
                flat
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('email_for_existing_candidate_account') }}</span>
              </template>
            </v-text-field>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="closeModal('base_create_contact');">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("close") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import { PhFloppyDisk, PhUserPlus, PhX } from "@phosphor-icons/vue";

export default {
  components: { BaseActionButton, BaseModal, BaseDraggableModal, PhFloppyDisk, PhX, PhUserPlus },
  props: ["person"],
  data() {
    return {
      record: {},
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.record = {
        contact_email: this.person.user.email,
        person_id: this.person.id,
      };
      if(this.person.emailaddresses && this.person.emailaddresses.length > 0) {
        for (let i = 0; i < this.person.emailaddresses.length; i++) {
          if (this.person.emailaddresses[i].emailaddress !== this.person.user.email) {
            this.record.candidate_email = this.person.emailaddresses[i].emailaddress;
            break;
          }
        }
      }
      this.openModal('base_create_contact');
    },
    async save() {
      if (!this.record.contact_email) {
        this.$toast.error(this.$store.getters.translate("required_field") + ": " + this.$store.getters.translate('contact') + " " + this.$store.getters.translate('email'));
      }
      /*else if (!this.record.candidate_email) {
        this.$toast.error(this.$store.getters.translate("required_field") + ": " + this.$store.getters.translate('candidate') + " " + this.$store.getters.translate('email'));
      }*/
      else {
        await helpFunctions.postCustomRoute(this.$toast, "user/create-contact", this.record, true, true);
        this.$emit('refresh');
        this.closeModal('base_create_contact');
      }
    },
  },
};
</script>